import { Box } from "@mui/system";
import React, { Component } from 'react';
import { Typography, Stack, Button } from "@mui/material";
import { Link } from "react-router-dom";

import { CircularProgress } from "@mui/material";
import { CardContent } from "@mui/material";
import { Grid } from "@mui/material";
import { Bar, BarChart, Cell, XAxis } from "recharts";
import wyzrTheme from "../styles/customTheme";
import { GradientButton } from "../components/ui-components/GradientButton";
import Carousel from 'react-material-ui-carousel'
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
import treeImage from "../images/tree.png";
import axios from "axios";
import { getURLBase } from "../utils/helperFns";


export class CarbonFootprintGraph extends Component {

    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/cf_graph"
        this.state = {
            isReady: true,
            activeIndex: 0,
            data: [],
            trees: 0,
            tonnes: 0,
            tutorial_iframe: "",
            your_emission: "-",
            uk_emission: "-",
        };
    }

    componentDidMount() {
        axios.post(this.url, { gid: this.props.gid }).then(res => {
            this.setState({
                data: res.data.body.data,
                trees: res.data.body.trees,
                tonnes: res.data.body.tonnes,
                activeIndex: res.data.body.data.length - 1,
                tutorial_iframe: res.data.body.tutorial_iframe,
                your_emission: res.data.body.your_emission,
                label: res.data.body.data[0].label.split(" ")[1]
            })
        }
        )
    }

    handleBarClick = (data, index) => {
        this.setState({
            activeIndex: index,
        });
    };

    CustomizedLabel = ({ x, y, width, stroke, value, name, index }) => {
        return (
            <text x={x + width / 2} y={y} fill="white" dy={"-0.8em"} fontSize={"1rem"} fontWeight={800} textAnchor="middle" dominantBaseline="text-after-edge" > 
            {index === this.state.activeIndex ? `${value} ${this.state.label}` : null}
            </text>
        )
    };

    render() {
        return (
            <Box className="carbonFootprintWrapper">

                <Grid container justifyContent={"center"}>
                    <Grid item xs={12} sm={10} md={7} lg={6}>


                        <Stack textAlign="center" marginBottom={2}>
                            <Typography variant="h4" color="white" fontWeight={700}>
                                Your Carbon Footprint
                            </Typography>

                            <Carousel className="w-100" autoPlay={false} animation="slide"
                                index={this.state.currentMonthIndex}
                                navButtonsAlwaysVisible={"auto"} cycleNavigation={false}
                                indicators={false}
                                navButtonsProps={{
                                    className: "owlButton-NoPad",
                                    style: {
                                        backgroundColor: 'transparent',
                                        color: "#82B879",
                                        fontSize: 50,
                                        padding: 0,
                                        margin: 0
                                    }
                                }}
                                activeIndicatorIconButtonProps={{
                                    style: {
                                        color: '#82B879'
                                    }
                                }}
                                PrevIcon={<ArrowLeftRoundedIcon fontSize="inherit" />}
                                NextIcon={<ArrowRightRoundedIcon fontSize="inherit" />}
                            >
                                <Box className="w-75">
                                    <Typography variant="h2" color="white">
                                        {this.state.tonnes}
                                    </Typography>

                                    <Typography variant="body1" color="white">
                                        CO<sub>2</sub>/yr
                                    </Typography>
                                </Box>
                                <Box className="w-75" container alignItems="center">
                                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                                        <Typography variant="h6" fontWeight={500} color="white">
                                            To absorb this carbon
                                        </Typography>

                                        <Stack direction="column" alignItems={"center"} justifyContent={"center"}>
                                            <Stack direction="row" justifyContent={"center"} width={"100%"}>
                                                <Typography align="center" variant="h3" color="white">{this.state.trees} x </Typography>
                                                <img src={treeImage} style={{ width: "2rem", height: "auto" }} />
                                            </Stack>
                                            <Typography variant="subtitle" color="white">in their lifetime</Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                                <Box className="w-75">


                                    <Grid container alignItems="center" justifyContent={"space-between"}>
                                        <Grid item md={5} xs={6}>
                                            <Box className="labelBg labelBgWhite">
                                                <Typography variant="body1" align="left">
                                                    Your emission
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item md={5} xs={6}>
                                            <Typography variant="h4" color="white">{this.state.your_emission}</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid container alignItems="center" justifyContent={"space-between"} mt={1}>
                                        <Grid item md={5} xs={6}>
                                            <Box className="labelBg labelBgRed">
                                                <Typography variant="body1" align="left">
                                                    UK Average
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item md={5} xs={6}>
                                            <Typography variant="h4" color="white">{this.state.uk_emission}</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Carousel>
                        </Stack>
                    </Grid>
                </Grid>

                <CardContent sx={{ paddingBottom: 0 }}>
                    {this.state.isReady ? (
                        <Box
                            className="flex-center-all"
                            sx={{ flexDirection: "column", marginTop: "15px" }}
                        >
                            <Box className="cfGraphWrapper" sx={{ padding: 4 }}>
                                <BarChart data={this.state.data} width={900} height={280}>
                                    <XAxis dataKey="name" fontWeight={700} tick={{ fill: "#fff" }} width={2000} />
                                    {/* <YAxis fontSize={12} fontWeight={700} lightingColor="#fff" tick={{ fill: "#fff" }} /> */}

                                    <Bar
                                        dataKey="amt"
                                        // label={{ fill: 'white', fontSize: 16, fontWeight: 800, position: "top" }}
                                        label={<this.CustomizedLabel  />}
                                        fill="#8884d8"
                                        onClick={this.handleBarClick}
                                        barSize={30}
                                        radius={[8, 8, 0, 0]}
                                    >
                                        {this.state.data.map((entry, index) => (
                                            <Cell
                                                cursor="pointer"
                                                fill={index === this.state.activeIndex ? wyzrTheme.palette.common.white : wyzrTheme.palette.grey[700]}
                                                key={`cell-${index}`}
                                            >
                                            </Cell>
                                        ))}
                                    </Bar>
                                </BarChart>
                            </Box>


                            <GradientButton textTransformtype="capitalize" component={Link} to="/carbon-footprint/take-action" sx={{ marginTop: 2 }}>
                                Offset Your Carbon Footprint
                            </GradientButton>
                            <Button sx={{ margin: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "-37px",
                          color: "white"
                           }}
                           onClick={() => this.props.setEmbedUrl(this.state.tutorial_iframe)}
                           >
                See how this works <img src="/tutorial-icon.png" style={{ width: "40px", padding: "5px"}}/>
						</Button>
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minHeight: "20vh",
                            }}
                        >
                            <CircularProgress color="success" />
                        </Box>
                    )}
                </CardContent>
            </Box>
        )
    }
}

const GraphData = () => {

}

export default CarbonFootprintGraph